<template>
  <div :class="{ 'crt-tearing': crtTearing }">
    <XpMobile v-if="isMobile" />
  <XpLoginScreen
    v-else-if="stage === 'login'"
    :current="currentLocale()"
    @login="enterDesktop"
    @power="stage = 'off'"
    @locale="switchLocale"
  />
  <div
    v-else-if="stage === 'loading'"
    class="xp-font xp-bg-loading grid min-h-screen place-items-center px-4 text-center"
  >
    <div>
      <p class="text-lg text-white">{{ t('xp.loading') }}</p>
      <div class="mx-auto mt-4 h-3 w-48 overflow-hidden rounded border border-white/50">
        <div class="xp-loading-bar h-full w-1/3" />
      </div>
    </div>
  </div>
  <div
    v-else-if="stage === 'off'"
    class="xp-font xp-bg-off grid min-h-screen place-items-center px-4 text-center"
  >
    <div>
      <p class="max-w-md text-2xl text-white drop-shadow-[2px_2px_2px_rgba(0,0,0,0.5)]">
        {{ t('xp.poweroff.title') }}
      </p>
      <button
        class="mt-6 rounded border border-white/60 px-4 py-2 text-white hover:bg-white/20"
        @click="stage = isMobile ? 'desktop' : 'login'"
      >
        {{ t('xp.poweroff.restart') }}
      </button>
    </div>
  </div>
  <XpDesktop v-else @logoff="stage = 'login'" @power="stage = 'off'" @locale="switchLocale" />
  </div>
  <CrtOverlay v-if="crtEnabled" />
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import XpLoginScreen from './xp/XpLoginScreen.vue'
import XpDesktop from './xp/XpDesktop.vue'
import XpMobile from './xp/XpMobile.vue'
import CrtOverlay from './xp/CrtOverlay.vue'
import { currentLocale, setLocale, type Locale } from './locales'
import { initTheme } from './composables/useTheme'
import { crtEnabled } from './composables/useCrt'
import { crtTearing } from './composables/useCrtTear'

type Stage = 'login' | 'loading' | 'desktop' | 'off'

const { t } = useI18n()
const stage = ref<Stage>('login')
const isMobile = ref(false)

let mq: MediaQueryList | null = null
function onMqChange(e: MediaQueryListEvent): void {
  isMobile.value = e.matches
}

function switchLocale(loc: Locale): void {
  setLocale(loc)
}

function enterDesktop(): void {
  stage.value = 'loading'
  window.setTimeout(() => {
    stage.value = 'desktop'
  }, 1500)
}

onMounted(() => {
  initTheme()
  mq = window.matchMedia('(max-width: 768px)')
  isMobile.value = mq.matches
  mq.addEventListener('change', onMqChange)
})

onBeforeUnmount(() => {
  mq?.removeEventListener('change', onMqChange)
})
</script>

<style>
.xp-loading-bar {
  background: linear-gradient(90deg, #7db9e8, #fff, #7db9e8);
  animation: xp-load 1.1s linear infinite;
}
@keyframes xp-load {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(300%);
  }
}
</style>
